import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapCollection } from '../../ruutsApi/normalize'

type OtherSite = {
  id: string
  name: string
  color?: string
  // Stored as [lat, lng], the reverse of GeoJSON's order.
  plannedLocation: [number, number]
}

export type OtherSiteFeature = {
  type: 'Feature'
  properties: {
    name: string
    id: string
    color?: string
    type: 'otherSite'
    featureGroup: 'otherSites'
  }
  geometry: { type: 'Point'; coordinates: [number, number] }
}

// OtherSite is the one mapping entity with no toGeoJSON virtual on the backend, so the
// map Feature is assembled here rather than read off the row.
export const getOtherSites = async ({
  farmId,
  signal,
}: {
  farmId: string
  signal?: AbortSignal
}): Promise<OtherSiteFeature[]> => {
  const response = await apiClient.get(endpoints.otherSites, { params: { farmId }, signal })
  return unwrapCollection<OtherSite>(response).map(otherSite => ({
    type: 'Feature',
    properties: {
      name: otherSite.name,
      id: otherSite.id,
      color: otherSite.color,
      type: 'otherSite',
      featureGroup: 'otherSites',
    },
    geometry: {
      type: 'Point',
      // The OtherSite model has no `location` field.
      coordinates: [otherSite.plannedLocation[1], otherSite.plannedLocation[0]],
    },
  }))
}
